import { sendGet } from './dataUtilities';
import env from '../env';
import { getUUID } from '../index';

const GET_USER_METADATA = '/customize/v1/public/users/';
const GET_INVENTORY_TIMER = '/customize/v1/public/inventory-timer/users/';
const GET_CHOOSED_PRODUCTS = '/api/1/public/choices/';
const GET_VALIDATE_CUSTOMIZATIONS = '/customize/v1/public/answers/verify/users/';
const GET_CAMPAIGN_INFO = '/customize/current/seasonal';

export type ProductChoice = {
  additionalQuantity: number;
  additionalItemCost: number;
  additionals: ProductChoice[];
  autoAssigned: false
  description: string;
  image: string;
  name: string;
  optionId: number;
  primaryQuantity: number;
  questionId: number;
  retailPrice: number;
  selectedBy: string;
  soldOut: boolean;
};

const getUserMetaData = () => {
  const uuid = getUUID();
  return sendGet(`${env.customizeUrl}${GET_USER_METADATA}${uuid}`, {});
};

const getTimer = () => {
  const uuid = getUUID();
  return sendGet(`${env.customizeUrl}${GET_INVENTORY_TIMER}${uuid}`, {});
};

const getChoosedProducts = () => {
  const uuid = getUUID();
  return sendGet(`${env.registerBaseUrl}${GET_CHOOSED_PRODUCTS}${uuid}`, {});
};

const getValidateCustomizations = () => {
  const uuid = getUUID();
  return sendGet(`${env.customizeUrl}${GET_VALIDATE_CUSTOMIZATIONS}${uuid}`, {});
};

const getCampaignInfo = () => sendGet(`${env.customizeUrl}${GET_CAMPAIGN_INFO}`, {});

export {
  getUserMetaData,
  getTimer,
  getChoosedProducts,
  getValidateCustomizations,
  getCampaignInfo,
};
